<template>
  <b-container class="mt-5" fluid>
    <b-row>
      <b-col class="d-flex justify-content-center">
        <!-- <h4 clas="text-center" v-if="oid">Order# {{ oid }} Acknowledgement</h4> -->
        <b-row>
          <b-col
            class="mt-5 d-flex justify-content-center"
            v-if="acknowledged && submitted"
          >
            <span
              class="mt-5 d-flex justify-content-center text-success"
              style="font-size:25px;"
            >
              Order# {{ oid }} has been acknowledge!
            </span>
          </b-col>
          <b-col v-else-if="!acknowledged && submitted">
            <span class="text-danger" style="font-weight:bold;font-size:20px;">
              Hmm. Something went wrong...<br />
            </span>
            <p class="text-danger" v-if="serverMsg">
              {{ serverMsg }}
            </p>
          </b-col>
          <b-col class="mt-5 d-flex justify-content-center" v-else>
            <span class="text-info">
              Submitting order status update, please wait...
              <b-spinner class="ml-2" small />
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: ["tk"],
  data() {
    return {
      serverMsg: null,
      acknowledged: false,
      submitted: false,
      oid: null
    };
  },
  mounted() {
    debugger;
    if (!this.tk) {
      var msg = "No token was found!";

      this.serverMsg = msg;
    }

    var me = this;

    this.$store.dispatch("orders/ackOrder", this.tk).then(r => {
      debugger;
      if (r.success) {
        me.serverMsg = r.msg.message;
        me.oid = r.msg.oid;
      } else {
        me.serverMsg = r.msg;
      }

      me.acknowledged = r.success;
      me.submitted = true;
    });
  }
  // methods: {
  //   onSubmit(e) {
  //     e.preventDefault();
  //     this.$store.dispatch("user/resetPass", this.creds).then(r => {
  //       if (r) {
  //         this.$router.push("/");
  //       } else {
  //         return;
  //       }
  //     });
  //   },
  //   onCancel() {
  //     this.$router.push("/");
  //   }
  // }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/OrderAcknowledge.vue